define('lib/Giphys',['require','underscore','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');
  var utils = require('lib/Podio.Utils');

  function load(mode, query, callback) {
    var requestData = {
      target: 'giphys',
      text: query,
      limit: 10
    };

    APITransport.request("post", "/reference/search", requestData).then(function(responseData) {
      var values = _.map(responseData, function(group, key) {
        return {
          "id": "giphys",
          "type": "group",
          "name": "Powered by Giphy",
          "contextIcon": "icon-126",
          "items": _.map(group.contents, function(giphy) {
            return {
              "id": giphy.id,
              "className": "giphy",
              "name": query,
              "type": "giphy",
              "contextIcon": giphy.preview
            };
          })
        };
      });
      callback(values);
    });
  }

  return {
    load: load
  };

});

